import React, { FunctionComponent, ReactNode } from 'react';

import { withTrack, WithTrack } from '../../utils/analytics';
import { useTranslation } from 'react-i18next';
import { useShareContext } from '../../context/ShareContext';
import { usePageMeta } from '../../hooks';
import { LinkButton } from './LinkButton';
import { ShareLabel } from './ShareLabel';

export type EmailShareProps = WithTrack & {
  className?: string;
  trackingData?: Record<string, any>;
  onClick?: () => void;
};

export const EmailShare: FunctionComponent<EmailShareProps> = ({
  className,
  track,
  trackingData,
  onClick,
}) => {
  const { shareItems } = useShareContext();
  const { isPreview } = usePageMeta();
  const { t } = useTranslation('common', { useSuspense: false });

  const trackClick = () => {
    track({
      action_name: 'click',
      subtype: 'share',
      event: 'click',
      event_value: 'email',
      ...trackingData,
    });
    if (onClick) {
      onClick();
    }
  };

  const as = !isPreview ? 'a' : 'div';
  const href = !isPreview
    ? `mailto:?subject=${encodeURIComponent(
        shareItems.email.subject,
      )}&body=${encodeURIComponent(shareItems.email.body)}`
    : undefined;
  const handleClick = !isPreview ? trackClick : undefined;
  return (
    <LinkButton
      as={as}
      dataQa="email-btn"
      href={href}
      onClick={handleClick}
      className={`jg-btn jg-btn--email ${className}`}
    >
      <ShareLabel labelText={t('common.email')} />
    </LinkButton>
  );
};

export default withTrack(EmailShare);
